import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import AdminLayout from "./layout/AdminLayout";
import VendorLayout from "./layout/VendorLayout";
import Dashboard from "./admin-pages/dashboard";
import VendorDashboard from "./vendor-pages/dashboard";
import Sigin from "./auth/adminauth/sigin";
import routes from "./routes/routes";
import VendorRegister from "./auth/adminauth/vendorregister";
import VendorVerified from "./auth/adminauth/vendorverifiy";
import VendorPolicy from "./vendor-pages/priveryploicy";
import VendorPrivacyPolicy from "./vendor-pages/priveryploicy";
import VendorCookiePolicy from "./vendor-pages/cookeiploicy";

const AppRoute = () => {
  const [loading, setLoading] = useState(true);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = window.localStorage.getItem("tokenfirst");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        console.log(decodedToken, "token value")
        setUserRole(decodedToken.userRole);
        setIsUserLoggedIn(true);
      } catch (error) {
        console.error("Token decoding error:", error);
        setIsUserLoggedIn(false);
      }
    }

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  useEffect(() => {
    if (!loading && !isUserLoggedIn) {
      const allowedUnauthPaths = ["/", "/vendorregister", "/vendorverify","/vendor-privacy-policy","/vendor-cookie-policy"];
      if (!allowedUnauthPaths.includes(window.location.pathname)) {
        navigate("/");
      }
    }
  }, [loading, isUserLoggedIn, navigate]);


  const isAdmin = userRole === 0;
  const isVendor = userRole === 1;

  const Loader = () => <div>Loading...</div>;

  if (loading) {
    return <Loader />;
  }

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={<Sigin />} />
        <Route path="/vendorregister" element={<VendorRegister />} />
        <Route path="/vendorverify" element={<VendorVerified />} />

        <Route path="/vendor-privacy-policy" element={<VendorPrivacyPolicy />} />
        <Route path="/vendor-cookie-policy" element={<VendorCookiePolicy />} />
        {isUserLoggedIn ? (
          <>
            {userRole === 0 ? (
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                {routes.adminRoutes.map(({ path, component: Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}
              </Route>
            ) : userRole === 1 ? (
              <Route element={<VendorLayout />}>
                <Route path="/vendor" element={<VendorDashboard />} />
                {routes.vendorRoutes.map(({ path, component: Component }) => (
                  <Route key={path} path={path} element={<Component />} />
                ))}
              </Route>
            ) : (
              <Route path="/*" element={<Navigate to="/" />} />
            )}
          </>
        ) : (
          <Route path="/*" element={<Navigate to="/" />} />
        )}
      </Routes>
    </Suspense>
  );
};

export default AppRoute;
